import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { VectorAIService } from "../../services";
import NavigatorComponent from "../navigator";
import SearchBoxComponent from "../search-box";
import { Menu } from "@material-ui/icons";

import HeaderDialogComponent from "./header-dialog.component";

import style from "./style";

const HeaderComponent: React.FC = () => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
  const history = useHistory();
  const classes = style();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleLogout = () => {
    VectorAIService.logout();
    history.replace("/login");
  };

  return (
    <Box
      display="flex"
      bgcolor={theme.palette.secondary.dark}
      py={2}
      className={classes.header}
      flexDirection="column"
    >
      <HeaderDialogComponent
        open={drawerOpen}
        onClose={() => setDrawerOpen(!drawerOpen)}
      />
      <Box
        display="flex"
        alignItems="center"
        py={isLargeScreen ? 1.5 : 0}
        p={isLargeScreen ? 0 : 2}
        flexGrow={1}
        justifyContent="center"
        flexWrap="wrap"
      >
        {!isLargeScreen && (
          <Menu
            onClick={() => setDrawerOpen(true)}
            style={{ color: theme.palette.common.white }}
          />
        )}
        <Typography
          style={{
            marginRight: theme.spacing(2),
            fontWeight: theme.typography.fontWeightLight,
            display: "flex",
            flexGrow: isLargeScreen ? 1 : 1,
            justifyContent: isLargeScreen ? "flex-start" : "center",
          }}
          color="textSecondary"
          variant="h5"
        >
          Vector AI
        </Typography>
        {isLargeScreen && (
          <React.Fragment>
            <SearchBoxComponent />
            <Button
              variant="contained"
              color="primary"
              size="large"
              disableRipple
              disableElevation
              onClick={handleLogout}
              style={{
                backgroundColor: theme.palette.primary.main,
                textTransform: "none",
                marginLeft: theme.spacing(),
              }}
            >
              Logout
            </Button>
          </React.Fragment>
        )}
      </Box>
      {isLargeScreen && <NavigatorComponent />}
    </Box>
  );
};

export default HeaderComponent;
